import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ClientService } from '../../../features/clients/services/client.service';
import { LayoutType } from '../../config/config';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];
  clientId: string;
  currentLayoutType: LayoutType | null;

  constructor(
    private clientService: ClientService,
    public router: Router,
    private layout: LayoutService
  ) {}

  ngOnInit(): void {
    this.clientService.currentClient$.subscribe(client => {
      if (client) {
        this.clientId = client.uuid;
      } else {
        console.warn('No client found. Client ID is undefined.');
      }
    });
    
    const layoutSubscr = this.layout.currentLayoutTypeSubject
      .asObservable()
      .subscribe((layout) => {
        this.currentLayoutType = layout;
      });
    this.unsubscribe.push(layoutSubscr);
  }

  onNavigate(route: string) {
    if (this.clientId && route === 'webhooks') {
      this.router.navigate([`/client/webhooks/${this.clientId}`]);
    } else if (route === 'stores') {
      this.router.navigate(['/client/stores']);
    } else {
      console.warn('Client ID is not defined or invalid route. Cannot navigate.');
    }
  }
  
  isViewingStore(): boolean {
    return this.router.url.includes('/client/store/');
  }

  isClientDetailView(): boolean {
    return this.router.url.includes('/client/stores') || this.router.url.includes('/client/webhooks');
  }

  goBackToHome(): void {
    this.router.navigate(['/']);
  }
  
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
